import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    MenuItem,
    Typography,
    CircularProgress,
    Alert,
    AlertTitle
} from "@mui/material";

import { sendDocument, getEmails } from "api/DocumentAPI";

const DocumentSendDialog = ({ open, setOpen, document }) => {
    const [email, setEmail] = useState("");
    const [knownEmails, setKnownEmails] = useState([]);
    const [useCustom, setUseCustom] = useState(false);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (open) {
            // setLoadingEmails(true);
            setEmail("");
            setUseCustom(false);
            setSuccessMessage("");
            setErrorMessage("");
            getEmails(
                (emails) => {
                    setKnownEmails(emails.map((item) => item.email));
                    // setLoadingEmails(false);
                },
                (error) => {
                    // setLoadingEmails(false);
                    setErrorMessage("Wystąpił błąd podczas ładowania adresów email.");
                    console.error("Error loading emails:", error);
                }
            );
        }
    }, [open]);


    const handleSend = () => {
        setLoading(true);
        setErrorMessage("");
        setSuccessMessage("");

        sendDocument(
            document,
            email,
            () => {
                setLoading(false);
                setSuccessMessage("Dokument został pomyślnie wysłany.");
                setTimeout(() => {
                    setEmail("");
                    setUseCustom(false);
                    setSuccessMessage("");
                    setOpen(false);
                }, 3000);
            },
            (error) => {
                setLoading(false);
                setErrorMessage("Wystąpił błąd podczas wysyłania dokumentu.");
                console.error("Error sending document:", error);
            }
        );
    };

    return (
        <Dialog open={open} onClose={() => {setOpen(false)}} fullWidth maxWidth="sm">
            <DialogTitle>Wyślij dokument emailem</DialogTitle>
            <DialogContent>
                <Typography gutterBottom>
                    <strong>Plik:</strong> {document.file_name}
                </Typography>

                {successMessage && (
                    <Alert severity="success" sx={{ mb: 2 }}>
                        <AlertTitle>Sukces</AlertTitle>
                        {successMessage}
                    </Alert>
                )}

                {errorMessage && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        <AlertTitle>Błąd</AlertTitle>
                        {errorMessage}
                    </Alert>
                )}

                {!useCustom ? (
                    <TextField
                        select
                        fullWidth
                        label="Wybierz adres email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        margin="normal"
                        disabled={loading}
                    >
                        {knownEmails.map((email) => (
                            <MenuItem key={email} value={email}>
                                {email}
                            </MenuItem>
                        ))}
                        <MenuItem value="" onClick={() => setUseCustom(true)}>
                            Inny adres...
                        </MenuItem>
                    </TextField>
                ) : (
                    <TextField
                        fullWidth
                        label="Wpisz adres email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        margin="normal"
                        type="email"
                        disabled={loading}
                    />
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={() => {setOpen(false)}} disabled={loading}>Anuluj</Button>
                <Button
                    onClick={handleSend}
                    variant="contained"
                    disabled={!email || loading}
                    startIcon={loading && <CircularProgress size={20} />}
                >
                    {loading ? "Wysyłanie..." : "Wyślij"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DocumentSendDialog;
